/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import color from '../../../constants/color';
import icons from '../../../constants/icons';
import {
  Button,
  CardForm,
  CardFormBody,
  ContainerForm,
  ContainerInfoImage,
  ContainerInfoImageHeader,
  FooterBotton,
  Img,
  Info,
  LoadingSize,
  MarginLeft,
  PageNumber,
  SizedBox,
  SizedBoxMultple,
  Space,
  TextButton,
} from './styles';
import InputFileCommon from '../../../components/inputFileCommon';
import InputCommon from '../../../components/inputCommon';
import Instructions from '../component/instructions';
import ListItemCommon from '../../../components/itemListCommon';
import { Criterios, GenericPlace } from '../../../interfaces';
import axios from '../../../services/poleposition';
import warn from '../../../constants/toast';
import ItemCard from '../../../components/itemCardCommon';
import imagem from '../../../utils/imagen';

interface Props {
  tipoPolePosition: number;
  goInit: Function;
  place?: Array<GenericPlace>;
  criterion?: Array<Criterios>;
}

const PoleBloqued: React.FC<Props> = ({
  goInit, place, criterion, tipoPolePosition,
}) => {
  const [benefitInput, setBenefitInput] = useState<Array<any>>([
    { from: 0, to: 0, end: 0 },
  ]);
  const [photoBase64, setPhotoBase64] = useState<string>('');
  const [poleNameError, setLocalNameError] = useState<boolean>(false);
  const [nameFile, setNameFile] = useState<string>('');
  const [poleName, setLocalName] = useState<string>('');
  const [hasPhoto, setHasPhoto] = useState<boolean>(false);
  const [isSelectImg, setIsSelectImg] = useState(true);
  const [isBenefitsPosition, setIsBenefitsPosition] = useState<boolean>(false);
  const [isPlace, setIsPlace] = useState<boolean>(false);
  const [isDiscretion, setIsDiscretion] = useState<boolean>(false);
  const [isEnd, setIsEnd] = useState<boolean>(false);
  const [quantidadeCorretoresBeneficiados, setQuantidadeCorretoresBeneficiados] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [places, setPlaces] = useState<Array<GenericPlace>>([]);
  const [criterions, setCriterions] = useState<Array<Criterios>>([]);
  const [loadingSave, setLoadingSave] = useState<boolean>(false);
  const [quantidadeCorretoresError, setQuantidadeCorretoresError] = useState<boolean>(false);
  const [photoError, setPhotoError] = useState<boolean>(false);
  const [messageError, setMessageError] = useState<boolean>(false);

  useEffect(() => {
    setPlaces(place?.map((item) => ({
      ...item,
      check: false,
    })) || []);
    setCriterions(criterion?.map((item) => ({
      ...item,
      check: false,
    })) || []);
  }, []);

  useEffect(() => {
    if (poleName && poleNameError) {
      setLocalNameError(false);
    }
    if (photoBase64 && photoError) {
      setPhotoError(false);
    }
    if (message && messageError) {
      setMessageError(false);
    }
    if (quantidadeCorretoresBeneficiados && quantidadeCorretoresError) {
      setQuantidadeCorretoresError(false);
    }
  }, [message, quantidadeCorretoresBeneficiados, poleName, photoBase64]);

  const savePolePosition = async () => {
    try {
      setLoadingSave(true);
      await axios.SavePolepostionBloqued(
        poleName,
        nameFile,
        message,
        imagem.filterImg(photoBase64) || '',
        criterions || [],
        places,
        benefitInput,
        tipoPolePosition,
        Number(quantidadeCorretoresBeneficiados),
      );
      setIsDiscretion(false);
      setIsEnd(true);
    } catch (error: any) {
      setLoadingSave(false);
      warn.wargingError(`${error?.response?.data?.notifications?.map((item: any) => `${item.message}\n`) || 'Erro status 500!'}`);
    }
  };

  const cleanState = () => {
    setLocalName('');
    setNameFile('');
    setPhotoBase64('');
    setMessage('');
    setPlaces(place || []);
    setCriterions(criterion || []);
  };

  const validation = () => {
    let error = false;

    if (!message) {
      setMessageError(true);
      error = true;
    }
    if (!quantidadeCorretoresBeneficiados) {
      setQuantidadeCorretoresError(true);
      error = true;
    }
    return error;
  };

  const uploadImageView = () => (
    <CardForm>
      <CardFormBody color="#FFF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <Img
              src={icons.arrowLeftBlueIcon}
              style={{ marginRight: 6 }}
              height={8}
              width={6}
            />
            <TextButton onClick={() => {
              goInit();
              setIsSelectImg(false);
            }}
            >
              VOLTAR
            </TextButton>
          </ContainerInfoImageHeader>
          <MarginLeft>
            <Instructions
              imageTop={icons.libraryIcon}
              title="Incluir nome e foto"
              subTitle={`Inclua uma foto que combine com o pole${'\n'}
              position e escolha um nome adequado.${'\n'}`}
              phase={1}
            />
          </MarginLeft>
        </ContainerInfoImage>
      </CardFormBody>
      <CardFormBody color="#E0E9FF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <PageNumber>01</PageNumber>
            <Info style={{ color: color.VivazBlack }}>Incluir nome e foto</Info>
          </ContainerInfoImageHeader>
          <SizedBoxMultple />
          <MarginLeft>
            <InputFileCommon
              isError={photoError}
              hasPhoto={hasPhoto}
              setHasPhoto={setHasPhoto}
              onChange={setPhotoBase64}
              onChangeFileName={setNameFile}
              photo={photoBase64}
            />
            <Space />
            <Space />
            <InputCommon
              isDisabled={false}
              isError={poleNameError}
              type="text"
              placeholder="Nome"
              value={poleName}
              onChange={setLocalName}
            />
            <SizedBoxMultple />
            <FooterBotton>
              <Button
                onClick={() => {
                  if (!poleName) {
                    setLocalNameError(true);
                    return toast.warning('Atenção, infome o nome do local.', {
                      style: {
                        backgroundColor: 'orange',
                      },
                    });
                  }

                  setIsSelectImg(false);
                  setIsBenefitsPosition(true);
                  return true;
                }}
                variant="contained"
                color="primary"
              >
                AVANÇAR
              </Button>
            </FooterBotton>
          </MarginLeft>
        </ContainerInfoImage>
        <Space />
      </CardFormBody>
    </CardForm>
  );
  const EarlyEntry = () => (
    <CardForm>
      <CardFormBody color="#FFF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <Img
              src={icons.arrowLeftBlueIcon}
              style={{ marginRight: 6 }}
              height={8}
              width={6}
            />
            <TextButton onClick={() => {
              setIsSelectImg(true);
              setIsBenefitsPosition(false);
            }}
            >
              VOLTAR
            </TextButton>
          </ContainerInfoImageHeader>
          <MarginLeft>
            <Instructions
              imageTop={icons.benefitIcon}
              title="Entrada antecipada"
              subTitle="Escolha quanto tempo antes alguns corretores porerão entrar para realizar as reservas."
              phase={2}
            />
          </MarginLeft>
        </ContainerInfoImage>
      </CardFormBody>
      <CardFormBody color="#E0E9FF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <PageNumber>02</PageNumber>
            <Info style={{ color: color.VivazBlack }}>Dados de entrada antecipada</Info>
          </ContainerInfoImageHeader>
          <Space />
          <Space />
          <MarginLeft>
            <SizedBox />
            <InputCommon
              isDisabled={false}
              isError={quantidadeCorretoresError}
              type="number"
              placeholder="Quantos corretores?"
              value={quantidadeCorretoresBeneficiados}
              onChange={setQuantidadeCorretoresBeneficiados}
            />
            <SizedBox />
            <InputCommon
              isDisabled={false}
              isError={messageError}
              type="number"
              multiline
              row={3}
              placeholder="Mensagem para o corretor"
              value={message}
              onChange={setMessage}
            />
            <Space style={{ marginTop: 8 }} />
            <FooterBotton>
              <Button
                onClick={() => {
                  if (!validation()) {
                    setIsBenefitsPosition(false);
                    setIsPlace(true);
                  } else {
                    warn.wargingAlert('Informe os dados!');
                  }
                }}
                variant="contained"
                color="primary"
              >
                AVANÇAR
              </Button>
            </FooterBotton>
          </MarginLeft>
        </ContainerInfoImage>
        <Space />
      </CardFormBody>
    </CardForm>
  );

  const selectPlace = () => (
    <CardForm>
      <CardFormBody color="#FFF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <Img
              src={icons.arrowLeftBlueIcon}
              style={{ marginRight: 6 }}
              height={8}
              width={6}
            />
            <TextButton onClick={() => {
              setIsPlace(false);
              setIsBenefitsPosition(true);
            }}
            >
              VOLTAR
            </TextButton>
          </ContainerInfoImageHeader>
          <MarginLeft>
            <Instructions
              imageTop={icons.pinIcon}
              title="Locais do pole position"
              subTitle="Escolha os locais que farão parte deste pole position"
              phase={3}
            />
          </MarginLeft>
        </ContainerInfoImage>
      </CardFormBody>
      <CardFormBody color="#E0E9FF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <PageNumber>03</PageNumber>
            <Info style={{ color: color.VivazBlack }}>Escolha os locais </Info>
          </ContainerInfoImageHeader>
          <SizedBoxMultple />
          <MarginLeft>
            {places?.map((item) => (
              <ListItemCommon
                onChange={(key: string) => {
                  setPlaces(places?.map((it) => {
                    if (it.idLocal === key) {
                      it.check = !it.check;
                      return it;
                    }
                    return it;
                  }));
                }}
                id={item.idLocal}
                check={item.check || false}
                photo={item.urlImagem}
                name={item.nome}
                isPhoto
              />
            ))}
            <Space style={{ marginTop: 8 }} />
            <FooterBotton>
              <Button
                onClick={() => {
                  if (places.every((item) => item.check === false)) {
                    warn.wargingAlert('Informe o local!');
                  } else {
                    setIsPlace(false);
                    setIsDiscretion(true);
                  }
                }}
                variant="contained"
                color="primary"
              >
                AVANÇAR
              </Button>
            </FooterBotton>
          </MarginLeft>
        </ContainerInfoImage>
        <Space />
      </CardFormBody>
    </CardForm>
  );

  const selectDiscretion = () => (
    <CardForm>
      <CardFormBody color="#FFF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <Img
              src={icons.arrowLeftBlueIcon}
              style={{ marginRight: 6 }}
              height={8}
              width={6}
            />
            <TextButton onClick={() => {
              setIsPlace(true);
              setIsDiscretion(false);
            }}
            >
              VOLTAR
            </TextButton>
          </ContainerInfoImageHeader>
          <MarginLeft>
            <Instructions
              imageTop={icons.discretionIcon}
              title="Critérios do pole position"
              subTitle="Nesta etapa você irá personalizar quais critérios serão utilizados neste pole position"
              phase={4}
            />
          </MarginLeft>
        </ContainerInfoImage>
      </CardFormBody>
      <CardFormBody color="#E0E9FF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader>
            <PageNumber>04</PageNumber>
            <Info style={{ color: color.VivazBlack }}>Definição de critérios</Info>
          </ContainerInfoImageHeader>
          <SizedBoxMultple />
          <MarginLeft>
            {criterions?.map((item) => (
              <ListItemCommon
                onChange={(key: string) => {
                  setCriterions(criterions?.map((it) => {
                    if (it.idCriterio === key) {
                      it.check = !it.check;
                      return it;
                    }
                    return it;
                  }));
                }}
                id={item.idCriterio}
                check={item.check || false}
                name={item.nome}
                isPhoto={false}
              />
            ))}
            <Space style={{ marginTop: 8 }} />
            <FooterBotton>
              <Button
                disabled={loadingSave}
                onClick={() => {
                  if (criterions.every((item) => item.check === false)) {
                    warn.wargingAlert('Informe as definições de critério!');
                  } else {
                    savePolePosition();
                  }
                }}
                variant="contained"
                color="primary"
              >
                {loadingSave ? (
                  <LoadingSize size={18} />
                ) : 'FINALIZAR'}
              </Button>
            </FooterBotton>
          </MarginLeft>
        </ContainerInfoImage>
        <Space />
      </CardFormBody>
    </CardForm>
  );

  const endRegister = () => (
    <CardForm>
      <CardFormBody color="#FFF">
        <ContainerInfoImage>
          <ContainerInfoImageHeader />
          <MarginLeft>
            <Instructions
              onClick={() => {
                cleanState();
                goInit(true);
                setIsEnd(false);
              }}
              imageTop={icons.checkEndIcon}
              title="Pole Position adicionado"
              subTitle="Parabéns, seu novo pole position foi cadastrado com sucesso"
              phase={5}
            />
          </MarginLeft>
        </ContainerInfoImage>
      </CardFormBody>
      <CardFormBody color="#E0E9FF">
        <ItemCard
          img={icons.noteIcon}
          title={poleName}
          icon={icons.viewIcon}
          subTitle1="Modelo: Online"
          subTitle2=""
          subTitle3={`Corretores: ${quantidadeCorretoresBeneficiados}`}
          onClick={() => {
          }}
          id="0"
        />
      </CardFormBody>
    </CardForm>
  );

  return (
    <>
      <ContainerForm>
        {isSelectImg && uploadImageView()}
        {isBenefitsPosition && EarlyEntry()}
        {isPlace && selectPlace()}
        {isDiscretion && selectDiscretion()}
        {isEnd && endRegister()}
      </ContainerForm>
    </>
  );
};

export default PoleBloqued;
